import IconVelaroDesignBrandingCustomize from "@/icons/IconVelaroDesignBrandingCustomize";
import { IconPlus, PrimaryBlueButton } from "@velaro/velaro-component-lib";
import React from "react";
import CreateModal from "./CreateModal";

interface Props {
  showCreateModal: boolean;
  setShowCreateModal: (show: boolean) => void;
  onCreate(name: string): Promise<void>;
  saving: boolean;
}

export default function NoDesignsAvailable(props: Props) {
  return (
    <div>
      <div className="flex justify-end mb-4">
        <PrimaryBlueButton
          prefixIcon={<IconPlus />}
          label="Create"
          onClick={() => props.setShowCreateModal(true)}
        />
      </div>
      <div className="w-full p-16 bg-white rounded-lg border border-slate-300 inline-flex flex-col justify-start items-center gap-4 overflow-hidden">
        <IconVelaroDesignBrandingCustomize />
        <div className="flex flex-col items-center gap-2">
          <div className="text-slate-800 text-xl font-medium">
            Create Your Chat Window
          </div>
          <div className="text-slate-500 text-sm font-normal w-[493px] text-center">
            It looks like you haven&apos;t created a chat window yet. Customize
            your chat window to attract visitors and match your brand&apos;s
            look.
          </div>
        </div>
      </div>
      {props.showCreateModal && (
        <CreateModal
          show={props.showCreateModal}
          onClose={() => props.setShowCreateModal(false)}
          onCreate={props.onCreate}
          saving={props.saving}
        />
      )}
    </div>
  );
}
